export const TRADABLE_ACCOUNTS = `StaticDataProfileImpl.tradableAccountCodes`;
export const TRADABLE_CLIENTS = `StaticDataProfileImpl.tradableClientCodes`;

// cycle breaking between auth-services & broker-client-services
